
const data =[
        {
            "id":"1",
            "image": "https://res.cloudinary.com/hayteetech/image/upload/v1640532243/Omakwaenergy/media1_p2vzki.jpg",
            "isImage":"true",
            "className":"layer-className",
            "name":"crude impacted vegetation"
        },
        {
            "id":2,
           "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532242/Omakwaenergy/media2_uhpox4.jpg",
           "isImage":true,
           "className":"layer-className",
           "name":"crude impacted vegetation"
        },

        {
            "id":3,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532243/Omakwaenergy/media3_khjqku.jpg",
           "isImage":true,
           "className":"layer-className",
           "name":"crude impacted vegetation"
        },
        {
            "id":4,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532238/Omakwaenergy/media4_djokff.jpg",
            "isImage":true,
            "className":"layer-className",
            "name":"site-cleanup"
        },
        {
            "id":5,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532239/Omakwaenergy/media5_hnohad.jpg",
            "isImage":true,
            "className":"layer-className",
            "name":"site cleanup"
        },
        {
            "id":6,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532238/Omakwaenergy/project1_bbhtfy.jpg",
            "isImage":true,
            "className":"layer-className",
            "name":"men at work"
        },
        {
            "id":7,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532407/Omakwaenergy/project2_sfpukz.jpg",
            "isImage":true,
            "className":"layer-className",
            "name":"men at work"
        },
        {
            "id":8,
            "image":"https://res.cloudinary.com/hayteetech/image/upload/v1640532407/Omakwaenergy/project2_sfpukz.jpg",
            "isImage":false,
            "className":"layer-className",
            "name":"videon at work"
        }
]
export default data